export { default } from './YotpoReviews';
